export const BACKGROUND_IMAGE_SOURCE = { uri: '/images/BannerRectangle.png' }
